module.exports = __webpack_public_path__ + "img/index-comp-pic5.8e15b0ba.png";